<app-spinner-service></app-spinner-service>

<form [formGroup]="descricaoPadraoForm" class="form-grid pt-2 pl-6 pr-6 pb-6" (ngSubmit)="onSubmit()">
  <fieldset class="form-block">
    <legend class="form-block-legend">Dados da Descrição Padrão</legend>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12">
        <label for="descricao">Descrição <span class="required">*</span></label>
        <input 
          id="descricao" 
          type="text" 
          pInputText 
          formControlName="descricao" 
          placeholder="Digite a descrição padrão"
          [ngClass]="{'invalid-field': descricaoPadraoForm.get('descricao')?.invalid && descricaoPadraoForm.get('descricao')?.touched}" />
        <small *ngIf="descricaoPadraoForm.get('descricao')?.invalid && descricaoPadraoForm.get('descricao')?.touched" class="error-message">
          Descrição é obrigatória.
        </small>
      </div>
    </div>
  </fieldset>

  <fieldset class="form-block mt-3">
    <legend class="form-block-legend">Informações Adicionais</legend>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12">
        <label for="detalhes">Detalhes<span class="required">*</span></label>
        <textarea 
          id="detalhes" 
          pInputTextarea 
          formControlName="detalhes" 
          rows="5"
          placeholder="Digite os detalhes da descrição padrão (Essa informação que irá aparecer na NFS-e)"
          [ngClass]="{'invalid-field': descricaoPadraoForm.get('detalhes')?.invalid && descricaoPadraoForm.get('detalhes')?.touched}"></textarea>
        <small class="field-hint">Informações adicionais sobre a descrição padrão</small>
        <small *ngIf="descricaoPadraoForm.get('detalhes')?.invalid && descricaoPadraoForm.get('detalhes')?.touched" class="error-message">
          Detalhes inválidos.
        </small>
      </div>
    </div>
  </fieldset>

  <div class="form-actions mt-4">
    <p-button type="button" label="Cancelar" icon="pi pi-times" severity="danger" (click)="onCancel()"></p-button>
    <p-button type="submit" label="Salvar" icon="pi pi-check" severity="success" [disabled]="descricaoPadraoForm.invalid"></p-button>
  </div>
</form>

